import React, { useState } from 'react'
import { Button, Table, Typography, Space, Image, Select } from 'antd'
import { jobData } from '../../../Data';
import { ActionButton, AlertModal } from '../..';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;
const { Text } = Typography;
const JobTable = () => {

    const navigate = useNavigate()
    const [deleteitem,setDeleteItem] = useState(false)


    const columns = [
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Job Title</Text>,
            dataIndex: 'title',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Organization Name</Text>,
            dataIndex: 'organizationname'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Client Name</Text>,
            dataIndex: 'clientName'

        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Budget</Text>,
            dataIndex: 'budget'

        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Status</Text>,
            dataIndex: 'status',
            render: (status) => {
                if (status === 'Active') {
                    return <Text className='active fs-12 badge-cs'>Active</Text>;
                } else if(status === 'Pending'){
                    return <Text className='pending fs-12 badge-cs'>Pending</Text>;
                } else{
                    return <Text className='inactive fs-12 badge-cs'>Inactive</Text>;
                }
            },
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Date</Text>,
            dataIndex: 'date'
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Action</Text>,
            key: 'action',
            fixed: 'right',
            width: 200,
            render: (_, row) => (
                <Space>
                    <Select
                        // onChange={(value) => onChange(value, row)}
                        className='fs-12'
                        defaultValue={'Active'}
                        // defaultValue={
                        //     row?.status === 1 ? 'Active' :
                        //     row?.status === 2 ? 'Pending' :
                        //     row?.status === 3 ? 'InActive' : ''
                        // }
                    >
                        <Option value="Active" >Active</Option>
                        <Option value="Pending">Pending</Option>
                        <Option value="InActive">InActive</Option>
                    </Select>
                    <ActionButton
                        title='Client View'
                        shape="circle"
                        icon={<Image src='/assets/icons/view.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {navigate(`/clients/detail/${row?.id}`)}}
                    />
                    <ActionButton
                        title='Delete Client'
                        shape="circle"
                        icon={<Image src='/assets/icons/delete.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setDeleteItem({name: row?.firstName})}}
                    />
                </Space>
            ),
        },
    ];
    return (
        <>
            <Table
                size='large'
                columns={columns}
                dataSource={jobData}
                className='pagination'
                showSorterTooltip={false}
                scroll={{ x: 1600 }}
                pagination={{
                hideOnSinglePage: true,
                total: 12,
                // pageSize: pagination?.pageSize,
                // defaultPageSize: pagination?.pageSize,
                // current: pagination?.pageNo,
                // size: "default",
                // pageSizeOptions: ['10', '20', '50', '100'],
                // onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                showTotal: (total) => <Button className='brand-bg border0 text-white'>Total: {total}</Button>,
            }}
        />
        <AlertModal
            visible={deleteitem}
            deleteitem={deleteitem}
            onClose={()=>{setDeleteItem(false)}}
        />
        </>
    )
}

export { JobTable }